import React, { Component } from "react";
import PropTypes from "prop-types";
import { Pages, Methods } from "arv-extends";
import * as Constants from "npmlinks-constants";
import lodashGet from "lodash.get";

const { Listing, Pdp, BrandPage, NotFound } = Pages;
const { pageType, GETTYPE_PAGEWISE_VALUES } = Constants;
const { isPdpPage, deduceValuesFromPipedData } = Methods;

class UiRoutingComponent extends Component {
  static contextTypes = {
    router: PropTypes.shape({
      staticContext: PropTypes.object,
    }),
  };
  selectedComponent() {
    const { staticContext } = (this.context && this.context.router) || {};
    const getType = window && window.getType;
    const currentPage =
      (window.history &&
        window.history.state &&
        window.history.state.state &&
        window.history.state.state.currentPage &&
        window.history.state.state.currentPage) ||
      "";
    if(getType) {
      console.log("Inside UiRouting Component, getType resolved ==>", getType);
    }
    else {
      console.log("Inside UiRouting Component, GetType not resolved");
    }
    const isCurrentStatePdp = currentPage === pageType.pdp;
    const isCurrentStateListing = currentPage === pageType.listing;
    const documentType = getType && getType.documentType;
    const { type } = deduceValuesFromPipedData(getType && getType.type);
    const finalType = documentType || type;
    const pathname =
      (staticContext &&
        staticContext.globalConfig &&
        staticContext.globalConfig.pathname) ||
      (window && window.location && window.location.pathname) ||
      "";
    const cidOverride =
      lodashGet(this, "context.router.staticContext.globalConfig.cid", null) ||
      window.location.search.indexOf("cid") > -1
      ? "Collection" : "";

    const pdpFallBack = isPdpPage(pathname) ? "Style" : "";

    let getPageType =   (cidOverride ||
    (isCurrentStatePdp && "Style") ||
    (isCurrentStateListing && "Collection") ||
    pdpFallBack ||
    finalType);

    console.log("Inside UiRouting Component, pageType => ", getPageType);

    return getPageType;
  
  }
  render() {
    const { props } = this;
    const type = this.selectedComponent();

    console.log("Inside UiRouting Component, page type received ==> ", type, " props received ==> ", props);
    
    switch (true) {
      case GETTYPE_PAGEWISE_VALUES.LISTING.includes(type):
        return <Listing.component {...props} />;
      case GETTYPE_PAGEWISE_VALUES.PDP.includes(type):
        return <Pdp.component {...props} />;
      case GETTYPE_PAGEWISE_VALUES.MASTER_TEMPLATE.includes(type):
        return <BrandPage.component {...props} />;
      default:
        return <NotFound.component {...props} />;
    }
  }
}
export default UiRoutingComponent;
